// extracted by mini-css-extract-plugin
export var resizer = "_fy-0";